const TEST_DOMAIN_SUFFIX = "-test";

export function normalizeDomain(domain: string): string {
  return domain.trim().toLowerCase();
}

export function getTestDomain(domain: string): string {
  const normalizedDomain = normalizeDomain(domain);
  const separatorIndex = normalizedDomain.indexOf(".");

  if (separatorIndex <= 0) {
    return "";
  }

  return `${normalizedDomain.slice(0, separatorIndex)}${TEST_DOMAIN_SUFFIX}${normalizedDomain.slice(separatorIndex)}`;
}

export function matchesDomainOrTestAlias(host: string, domain: string): boolean {
  const normalizedHost = normalizeDomain(host);
  const normalizedDomain = normalizeDomain(domain);

  return (
    normalizedHost === normalizedDomain ||
    normalizedHost === getTestDomain(normalizedDomain)
  );
}

export function isProductionDomain(host: string, domains: string[]): boolean {
  const normalizedHost = normalizeDomain(host);

  return domains.some((domain) => normalizedHost === normalizeDomain(domain));
}
